export enum TradeSessionStatus {
  /**
   * 报名未开始
   */
  WAIT_APPLY_START = 0,

  /**
   * 报名中
   */
  APPLYING = 1,

  /**
   * 竞价未开始
   */
  WAIT_BID_START = 2,

  /**
   * 出价中
   */
  BIDDING = 3,

  /**
   * 竞价已结束
   */
  BID_END = 4
}

export const TradeSessionStatusTextMap = {
  [TradeSessionStatus.WAIT_APPLY_START]: '待报名',
  [TradeSessionStatus.APPLYING]: '报名中',
  [TradeSessionStatus.WAIT_BID_START]: '未开始',
  [TradeSessionStatus.BIDDING]: '竞价中',
  [TradeSessionStatus.BID_END]: '已结束'
}

export const TradeSessionStatusColorMap = {
  [TradeSessionStatus.WAIT_APPLY_START]: 'colorPrimary',
  [TradeSessionStatus.APPLYING]: 'colorPrimary',
  [TradeSessionStatus.WAIT_BID_START]: 'colorPrimary',
  [TradeSessionStatus.BIDDING]: 'colorError',
  [TradeSessionStatus.BID_END]: 'colorText'
} as const
